import * as moment from "moment";

export class PortalMember {
    constructor(json?: any) {
        this.id = json && json.id || null;
        this.appUserID = json && json.app_user_id || null;
        this.portalID = json && json.portal_id || null;
        this.portalRoleID = json && json.portal_role_id || null;
        this.isStaff = json && json.is_staff || null;
        this.renewalCount = json && json.renewal_count || 0
        this.inactive = json && json.inactive || false;
        this.childPortalID = json && json.child_portal_id || null;
        this.parentAccess = json && json.parent_access || null;
        this.isRinknetStaff = json && json.is_rinknet_staff || null;
        this.userInParent = json && json.user_in_parent || null;

        if (json && json.membership_start_date) {
            this.membershipStartDate = moment(json.membership_start_date);
        }

        if (json && json.membership_end_date) {
            this.membershipEndDate = moment(json.membership_end_date);
        }

        if (json && json.membership_renewal_date) {
            this.membershipRenewalDate = moment(json.membership_renewal_date);
        }

/*         if (this.userInParent) {
            this.parentAccess = true;
        } */
    }

    id: number;
    appUserID: number;
    portalID: number;
    portalRoleID: number;
    isStaff: boolean;
    membershipStartDate: moment.Moment;
    membershipEndDate: moment.Moment;
    membershipRenewalDate: moment.Moment;
    renewalCount: number;
    inactive: boolean;
    childPortalID: number;
    parentAccess: boolean;
    isRinknetStaff: boolean;
    userInParent: boolean;

    toJSON() {
        return {
            id: this.id,
            app_user_id: this.appUserID,
            portal_id: this.portalID,
            portal_role_id: this.portalRoleID,
            is_staff: this.isStaff,
            renewal_count: this.renewalCount,
            inactive: this.inactive,
            child_portal_id: this.childPortalID,
            parent_access: this.parentAccess,
            is_rinknet_staff: this.isRinknetStaff
        }
    }
}